import { cva } from 'class-variance-authority';

import styles from './Progress.module.css';

export const progressVariants = cva(styles.progress, {
  variants: {
    fullWidth: {
      true: styles['progress--full-width'],
    },
  },
});
